import { Alert } from "./../models/Alert";
import { SystemConfig } from "./../models/SystemConfig";
import {
  OBS_IS_UNDER_MAINTENANCE,
  IN_OPERATION_MODE,
  IN_MAINTENANCE_MODE,
  POSTAL_CODE,
  SINGAPORE_PHONE_NO,
  SUSPENDED
} from "./../app.constant";
import { SystemDataService } from "./../service/data/system-data.service";
import { BasicAuthenticationService } from "./../auth/basic-authentication.service";
import { Account } from "./../models/account";
import { AccountDataService } from "./../service/data/account-data.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  MaxLengthValidator
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ElementSchemaRegistry } from '@angular/compiler';

@Component({
  selector: "app-my-details",
  templateUrl: "./my-details.component.html",
  styleUrls: ["./my-details.component.css"]
})
export class MyDetailsComponent implements OnInit {
  readonly MY_DETAIL_TAB_TOP_POSITION: string = "my_detail_tab_top_position";

  alertsOnMyDetailTab: Alert[] = [];

  loginAccount: Account;

  allAccounts: Account[];

  isSuspended: boolean;

  accountDetailsForm: FormGroup;

  showSuspendOption: boolean;

  showUnsuspendOption: boolean;

  currentSelectedAccount: Account;

  idDropDownDisabled: boolean;

  showChangePasswordField: boolean;

  @ViewChild('userConfirmationModal', { static: false })
  private userConfirmationModal;

  @ViewChild('userSuspendConfirmationModal', { static: false })
  private userSuspendConfirmationModal;

  constructor(
    private fb: FormBuilder,
    private accountDataService: AccountDataService,
    private basicAuthenticationService: BasicAuthenticationService,
    private systemDataService: SystemDataService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.initialise(null);
  }

  async initialise(alertMessage: AlertMessage) {
    this.alertsOnMyDetailTab = [];
    this.allAccounts = [];
    this.showSuspendOption = false;
    this.showUnsuspendOption = false;
    this.idDropDownDisabled = false;
    this.showChangePasswordField = false;

    this.accountDetailsForm = this.fb.group(
      {
        fullName: ["", Validators.required],
        email: ["", [Validators.required, Validators.email]],
        phoneNo: [
          "",
          [Validators.required, Validators.pattern(SINGAPORE_PHONE_NO)]
        ],
        address: ["", Validators.required],
        postalCode: [
          "",
          [Validators.required, Validators.pattern(POSTAL_CODE)]
        ],
        sendAlertViaEmail: true,
        newPassword: [""],
        confirmPassword: [""]
      },
      { validator: this.checkPasswords }
    );

    this.currentSelectedAccount = new Account(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      new Date(),
      "",
      "",
      1,
      "",
      "",
      1,
      1,
      1,
      new Date(),
      "",
      new Date(),
      ""
    );

    let response = await this.getMaintenanceStatus();

    var firstKey = Object.keys(response)[0];

    var systemConfig: SystemConfig;

    if (firstKey.toUpperCase() == "OK") {
      systemConfig = response[firstKey];

      if (systemConfig.value == IN_OPERATION_MODE) {
        // Get current login account

        let response = await this.getAccount(
          this.basicAuthenticationService.getAuthenticatedUser()
        );

        var firstKey = Object.keys(response)[0];

        if (firstKey.toUpperCase() == "OK") {
          this.loginAccount = response[firstKey];

          this.allAccounts.push(this.loginAccount);

          this.pushSubAccountsIntoAllAccountVariable(
            this.loginAccount.accountId
          );

          this.idDropDownDisabled =
            this.loginAccount.accountId != this.loginAccount.mainAccountId;

          this.selectAccount(this.loginAccount, false, true);
        }
      } else if (systemConfig.value == IN_MAINTENANCE_MODE) {
        this.basicAuthenticationService.clearSession();

        this.router.navigate(["maintenance"]);
      }
    } else if (firstKey.toUpperCase() == "ERROR") {
    }

    console.log("alertMessage" + JSON.stringify(alertMessage));

    if (alertMessage) this.showAlertMessage(alertMessage);
  }

  showUserConfirmationModal() {
    this.modalService.open(this.userConfirmationModal).result.then(
      closeResult => {
        //this.selectedDeceasedProfile = [];
      },
      dismissReason => {
        //this.selectedDeceasedProfile = [];
      }
    );
  }

  showSuspendUserConfirmationModal() {
    this.modalService.open(this.userSuspendConfirmationModal).result.then(
      closeResult => {
        //this.selectedDeceasedProfile = [];
      },
      dismissReason => {
        //this.selectedDeceasedProfile = [];
      }
    );
  }


  closeUserConfirmationModal() {
    this.modalService.dismissAll();
  }

  public getMaintenanceStatus(): Promise<any> {
    return this.systemDataService
      .getSystemConfig(OBS_IS_UNDER_MAINTENANCE)
      .toPromise();
  }

  public getAccount(accountId: string): Promise<any> {
    return this.accountDataService.getAccount(accountId).toPromise();
  }

  changePasswordButtonIsDisabled: boolean = false;
  updateProfileButtonIsDisabled: boolean = false;

  suspend(){

    this.currentSelectedAccount.status = 'SUSPENDED';

    this.updateProfile();

    this.idSelectedInDropDownList(this.currentSelectedAccount.accountId);
  }

  unsuspend(){

    this.currentSelectedAccount.status = 'ACTIVE';

    this.updateProfile();

    
    this.idSelectedInDropDownList(this.currentSelectedAccount.accountId);
  }

  public selectAccount(
    account: Account,
    canUpdateAccountStatus: boolean,
    canUpdateProfile: boolean
  ) {
    this.currentSelectedAccount = account;

    this.showChangePasswordField = false;

    this.accountDetailsForm.setValue({
      fullName: account.fullName,
      email: account.emailAddress,
      phoneNo: account.phoneNo,
      address: account.address,
      postalCode: account.postalCode,
      sendAlertViaEmail: account.receiveEmailReminder == 1 ? true : false,
      newPassword: "",
      confirmPassword: ""
    });

    if (canUpdateProfile) {
      this.accountDetailsForm.controls["fullName"].enable();
      this.accountDetailsForm.controls["email"].enable();
      this.accountDetailsForm.controls["phoneNo"].enable();
      this.accountDetailsForm.controls["address"].enable();
      this.accountDetailsForm.controls["postalCode"].enable();
      this.accountDetailsForm.controls["sendAlertViaEmail"].enable();
      this.accountDetailsForm.controls["newPassword"].enable();
      this.accountDetailsForm.controls["confirmPassword"].enable();

      this.changePasswordButtonIsDisabled = false;
      this.updateProfileButtonIsDisabled = false;
    } else {
      this.accountDetailsForm.controls["fullName"].disable();
      this.accountDetailsForm.controls["email"].disable();
      this.accountDetailsForm.controls["phoneNo"].disable();
      this.accountDetailsForm.controls["address"].disable();
      this.accountDetailsForm.controls["postalCode"].disable();
      this.accountDetailsForm.controls["sendAlertViaEmail"].disable();
      this.accountDetailsForm.controls["newPassword"].disable();
      this.accountDetailsForm.controls["confirmPassword"].disable();

      this.changePasswordButtonIsDisabled = true;
      this.updateProfileButtonIsDisabled = true;
    }

    this.isSuspended = account.status.toLowerCase() == "suspended";

    this.showSuspendOption = false;
    this.showUnsuspendOption = false;

    if (canUpdateAccountStatus) {
      if (this.isSuspended) {
        this.showUnsuspendOption = true;
      } else {
        this.showSuspendOption = true;
      }
    }
  }

  idSelectedInDropDownList(idSelected: string) {
    this.allAccounts.forEach(element => {
      if (element.accountId == idSelected) {
        let loginIsMain =
          this.loginAccount.accountId == this.loginAccount.mainAccountId;
        let subAccountIdSelected = idSelected != this.loginAccount.accountId;
        let canUpdateAccountStatus = loginIsMain && subAccountIdSelected;

        let canUpdateProfile = this.loginAccount.accountId == idSelected;

        this.selectAccount(element, canUpdateAccountStatus, canUpdateProfile);
      }
    });
  }

  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    let pass: string = group.get("newPassword").value;
    let confirmPass: string = group.get("confirmPassword").value;

    var result = null;

    if(pass !== confirmPass){
      result = { notSame: true };
    }else
      if(pass.length < 6 || confirmPass.length < 6){
        result = { violateMinLength: true };
      }
      ElementSchemaRegistry
        if(pass.length > 20 || confirmPass.length > 20){
          result = { violateMaxLength: true };
        }
      

    //return pass === confirmPass ? null : { notSame: true };

    return result;
  }

  showFormValidationAlert(formGroup :FormGroup): boolean{
    let alertMessage = {
      response: '',
      position: this.MY_DETAIL_TAB_TOP_POSITION,
      milleseconds: 3000
    };

    let invalid = false;

    if (this.accountDetailsForm.controls["email"].invalid) {

      let alertArr = Array.from([{ type: 'danger', message: 'Invalid email.' }]);

      this.alertsOnMyDetailTab = alertArr;
      setTimeout(() => {
        this.alertsOnMyDetailTab = [];
      }, 3000);

      invalid = true;
    }
    else if (this.accountDetailsForm.controls["phoneNo"].invalid) {

      let alertArr = Array.from([{ type: 'danger', message: 'Invalid phone number.' }]);

      this.alertsOnMyDetailTab = alertArr;
      setTimeout(() => {
        this.alertsOnMyDetailTab = [];
      }, 3000);

      invalid = true;
    }
    else if (this.accountDetailsForm.controls["address"].invalid) {

      let alertArr = Array.from([{ type: 'danger', message: 'Invalid address.' }]);

      this.alertsOnMyDetailTab = alertArr;
      setTimeout(() => {
        this.alertsOnMyDetailTab = [];
      }, 3000);

      invalid = true;
    }
    else if (this.accountDetailsForm.controls["postalCode"].invalid) {

      let alertArr = Array.from([{ type: 'danger', message: 'Invalid postal code.' }]);

      this.alertsOnMyDetailTab = alertArr;
      setTimeout(() => {
        this.alertsOnMyDetailTab = [];
      }, 3000);

      invalid = true;
    }else
      if(this.showChangePasswordField)
      {
        if(this.checkPasswords(this.accountDetailsForm)!=null){
          invalid = true;
        }
      }

      return invalid;
  }

  updateProfile() {

    this.closeUserConfirmationModal();

    if (this.showFormValidationAlert(this.accountDetailsForm)) {
      return;
    }

    this.currentSelectedAccount.emailAddress = this.accountDetailsForm.controls[
      "email"
    ].value;
    this.currentSelectedAccount.phoneNo = this.accountDetailsForm.controls[
      "phoneNo"
    ].value;
    this.currentSelectedAccount.address = this.accountDetailsForm.controls[
      "address"
    ].value;
    this.currentSelectedAccount.postalCode = this.accountDetailsForm.controls[
      "postalCode"
    ].value;
    this.currentSelectedAccount.receiveEmailReminder =
      this.accountDetailsForm.controls["sendAlertViaEmail"].value == true
        ? 1
        : 0;

    if (this.showChangePasswordField) {
      this.currentSelectedAccount.password = this.accountDetailsForm.controls[
        "newPassword"
      ].value;
    } else {
      this.currentSelectedAccount.password = '';
    }

    this.accountDataService
      .updateAccount(this.currentSelectedAccount)
      .subscribe(
        response => {
          var firstKey = Object.keys(response)[0];

          let alertMessage = {
            response: response,
            position: this.MY_DETAIL_TAB_TOP_POSITION,
            milleseconds: 5000
          };

          this.showAlertMessage(alertMessage);

          if (firstKey.toUpperCase() == "OK") {
            if (this.currentSelectedAccount.password.length > 0) {

              this.accountDataService.getAccount(this.currentSelectedAccount.accountId)
                .subscribe(
                  response => {

                    var key = Object.keys(response)[0];
                    if (key.toUpperCase() == "OK") {

                      var accountWithNewPassword = response[firstKey];
                      accountWithNewPassword.password = this.currentSelectedAccount.password;

                      this.accountDataService
                        .updatePassword(accountWithNewPassword)
                        .subscribe(
                          response => {
                            let alertMessage = {
                              response: response,
                              position: this.MY_DETAIL_TAB_TOP_POSITION,
                              milleseconds: 5000
                            };

                            this.showAlertMessage(alertMessage);
                          },
                          error => { }
                        );
                    }
                  }
                )
            }
          }
        },
        error => { }
      );
  }

  showChangePasswordFieldChanged() {
    //Change Password is toggle on and off
    if (!this.showChangePasswordField) {
      this.accountDetailsForm.controls["newPassword"].setValue('');
      this.accountDetailsForm.controls["confirmPassword"].setValue('');
    }
  }

  showAlertMessage(alertMessage: AlertMessage) {
    var firstKey = Object.keys(alertMessage.response)[0];

    let finalMessage = alertMessage.response[firstKey];
    let alertType = firstKey.toUpperCase() == "OK" ? "success" : "danger";

    let alertArr = Array.from([{ type: alertType, message: finalMessage }]);

    if (alertMessage.position === this.MY_DETAIL_TAB_TOP_POSITION) {
      this.alertsOnMyDetailTab = alertArr;
      setTimeout(() => {
        this.alertsOnMyDetailTab = [];
      }, alertMessage.milleseconds);
    }
  }

  pushSubAccountsIntoAllAccountVariable(mainAccountId: string) {
    let subAccounts: Account[];

    this.accountDataService
      .getSubAccountByMainAccountId(mainAccountId)
      .subscribe(
        response => {
          var firstKey = Object.keys(response)[0];

          if (firstKey.toUpperCase() == "OK") {
            subAccounts = response[firstKey];

            subAccounts.forEach(subAccount => {
              this.allAccounts.push(subAccount);
            });
          } else if (firstKey.toUpperCase() == "ERROR") {
          }
        },
        error => { }
      );
  }
}

export interface AlertMessage {
  response: any;
  position: string;
  milleseconds: number;
}
